module.exports = __webpack_public_path__ + "img/aw.29aeb3f.svg";